import Model from 'flarum/common/Model';
export default class Colaboracion extends Model {}
Colaboracion.prototype.colabType = Model.attribute('type');
Colaboracion.prototype.tagId = Model.attribute('tagId');
Colaboracion.prototype.adminGroupId = Model.attribute('adminGroupId');
Colaboracion.prototype.isActive = Model.attribute('isActive');
Colaboracion.prototype.description = Model.attribute('description');
Colaboracion.prototype.email = Model.attribute('email');
Colaboracion.prototype.phone = Model.attribute('phone');
Colaboracion.prototype.address = Model.attribute('address');
Colaboracion.prototype.websiteUrl = Model.attribute('websiteUrl');
Colaboracion.prototype.facebookUrl = Model.attribute('facebookUrl');
Colaboracion.prototype.instagramUrl = Model.attribute('instagramUrl');
Colaboracion.prototype.twitterUrl = Model.attribute('twitterUrl');
Colaboracion.prototype.youtubeUrl = Model.attribute('youtubeUrl');
Colaboracion.prototype.spotifyUrl = Model.attribute('spotifyUrl');
Colaboracion.prototype.whatsappUrl = Model.attribute('whatsappUrl');
Colaboracion.prototype.lastPostedAt = Model.attribute('lastPostedAt', Model.transformDate);
Colaboracion.prototype.createdAt = Model.attribute('createdAt', Model.transformDate);
Colaboracion.prototype.updatedAt = Model.attribute('updatedAt', Model.transformDate);
flarum.reg.add('nagusi-match-ratings', 'common/models/Colaboracion', Colaboracion);